import React from "react";
import { Icon, Input, Rating } from "semantic-ui-react";

export function ClearableRating({ onChange, value, style }) {
  return (
    <Input
      input={() => (
        <Rating
          maxRating={5}
          icon="star"
          size="small"
          rating={value}
          onRate={(_ev, { rating }) => onChange(rating)}
        />
      )}
      icon={<Icon name="x" link onClick={() => onChange(null)} />}
      style={{
        padding: 10,
        borderRadius: ".285rem",
        border: "1px solid rgba(34,36,38,.15)",
        ...style,
      }}
    />
  );
}
